import { collection, addDoc, getDocs, query, where } from "firebase/firestore";
import { db } from "./firebaseConfig";

// スキルを保存する
export async function saveSkill(skill) {
  try {
    const docRef = await addDoc(collection(db, "skills"), skill);
    console.log("スキルが保存されました:", docRef.id);
  } catch (error) {
    console.error("スキルの保存中にエラーが発生しました:", error);
  }
}

// ユーザーのスキルを取得する関数
export async function fetchSkills(userId) {
  console.log("Fetching skills for userId:", userId);  // userIdの確認
  const skills = [];
  try {
    // Firestoreから全てのスキルを取得するクエリを作成
    const q = query(collection(db, "skills"), where("userId", "==", userId));  // ユーザーIDでフィルタリング
    const querySnapshot = await getDocs(q);  // クエリの実行
    console.log("querySnapshot:", querySnapshot);  // クエリ結果のログ
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      console.log("Document data:", data);  // ドキュメントデータの確認
      skills.push({ id: doc.id, ...data });  // スキルをskills配列に追加
    });
  } catch (error) {
    console.error("スキルの取得中にエラーが発生しました:", error);  // エラー時のログ
  }
  console.log("Fetched skills:", skills);  // 取得したスキルのログ
  return skills;  // スキルを返す
}

// ユーザーごとのスキルを取得する
export async function getSkillsByUser(userId) {
  const skills = [];
  try {
    const q = query(collection(db, "skills"), where("userId", "==", userId));
    const querySnapshot = await getDocs(q);
    
    console.log("クエリ結果:", querySnapshot);  // クエリ結果をデバッグ用に表示

    querySnapshot.forEach((doc) => {
      console.log("取得したドキュメント:", doc.id, doc.data());  // 各ドキュメントを表示
      skills.push({ id: doc.id, ...doc.data() });
    });

    console.log("取得したスキル:", skills);  // 取得したスキルを表示
  } catch (error) {
    console.error("ユーザーのスキル取得中にエラーが発生しました:", error);
  }
  return skills;  // 取得したスキルを返す
}
